import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
})
export class PaymentDetailsComponent  implements OnInit {
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {}

  clickClose(){
    this.closePopup.emit();
  }

}
